<template>
  <div class="transfer__wrapper transfer-payment-method">
    <!-- Шаг 1: Выбор метода оплаты -->
    <form-layout
      v-if="currentStep === 1"
      :main-title="$t('superPass.purchase.title')"
      :mobile-title="$t('superPass.purchase.title')"
      :small-title="true"
      submit-text="Далее"
      @back="goBack"
      @submit="goToNextStep"
    >
      <div class="payments-content__body">
        <Loader v-if="loading" />
        <div class="payments-content__body__header">
          <div class="payments-content__body__header__left">
            <div class="payments-content__body__header__image">
              <img src="@/assets/images/payments/payments-ico.svg" alt="ico" />
            </div>
            <span>
              {{ $t('payment.selectPaymentMethod') }}
            </span>
          </div>
        </div>
        <PaymentMethodsList :current="selectedMethodName" :list="methodsInCustomOrder" @select="choosePaymentMethod" />
      </div>

      <div class="payments-content__info">
        <div class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.replenishmentAmount') }}</div>
          <Input
            v-model.trim="amount"
            type="number"
            :icon-text="currencyMap[$store.state.currency]"
            :placeholder="$t('payment.enterSum')"
            :state="error.message ? 'error' : 'default'"
            :error="error.message"
            :disabled="true"
            @keyup.enter="goToNextStep"
            @blur="validatePrice"
          />
        </div>

        <div v-if="isNeedEmail" class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.email') }}</div>
          <Input
            v-model.trim="email"
            icon-text="%"
            placeholder="E-mail"
            :state="emailError.message ? 'error' : 'default'"
            :error="emailError.message"
            :disabled="true"
            @keyup.enter="goToNextStep"
          />
        </div>

        <div class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.commission') }}:</div>
          <Input
            v-model.trim="commissionValue"
            icon-text="%"
            :placeholder="$t('payment.commission')"
            :disabled="true"
            @keyup.enter="goToNextStep"
          />
        </div>
      </div>
    </form-layout>

    <!-- Шаг 2: Подтверждение с данными SuperPass -->
    <form-layout
      v-if="currentStep === 2"
      :main-title="$t('superPass.purchase.title')"
      :small-title="true"
      :title="$t('superPass.purchase.title')"
      :sub-title="$t('superPass.purchase.subTitle')"
      :submit-text="$t('payment.pay')"
      :disabled="loading"
      @back="currentStep = 1"
      @submit="createOrder"
    >
      <div class="payments-step-2">
        <div class="payments-step-2__info">
          <PurchasePassCard title="Выбранная игра:" :entity="game" @edit="changeModal('SuperPassGames')" />
          <PurchasePassCard title="Выбранный пасс:" :entity="pass" @edit="changeModal('SuperPassPasses')" />

          <div class="payments-step-2__method">
            <Input :value="paymentMethodName" :disabled="true" icon="/base/payment.svg" placeholder="Метод оплаты" />
            <span class="payments-step-2__method-commission">
              Комиссия {{ $store.state.paymentsOrder.selectedMethod.commission }}%
            </span>
          </div>

          <div class="payments-step-2__infoPay">
            <Input
              :value="pass.amount[$store.state.currency] + ' ' + currencyMap[$store.state.currency]"
              :disabled="true"
              :icon-text="currencyMap[$store.state.currency]"
              :placeholder="$t('payment.replenishmentAmount')"
            />
            <Input :value="pass.robux + ' R$'" :disabled="true" icon="/base/robux.svg" placeholder="Робуксы" />
          </div>
        </div>

        <p class="payments-step-2__result">
          {{ $t('payment.toPay') }}:
          <span>
            {{ commissionValue }}
            {{ currencyMap[$store.state.currency] }}
          </span>
        </p>
      </div>
    </form-layout>
  </div>
</template>

<script>
import languages from '@/constants/languages'
import paymentsMethodsInfo from '@/constants/paymentsMethodsInfo'
import { validateEmail } from '@/utils/validate'
import { getCommissionNewLava } from '@/utils/formatting'
import { getPaymentMethodName, makePayment } from '@/utils/paymentMethods'
import { mapGetters } from 'vuex'
import Loader from '@/components/LoaderBar/LoaderBar'
import ipUtil from '@/utils/ip'
import Input from '@/components/Base/Input/Input.vue'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import PaymentMethodsList from '@/components/PaymentMethodsList/PaymentMethodsList.vue'
import PurchasePassCard from '@/components/PurchasePassCard/PurchasePassCard.vue'
import { METHODS_ORDER } from '@/constants/paymentMethods'
import paymentSubStep from '@/mixins/paymentSubStep'

export default {
  name: 'SuperPassPaymentMethod',
  components: {
    PaymentMethodsList,
    FormLayout,
    Input,
    Loader,
    PurchasePassCard
  },
  inject: ['currencyMap'],
  mixins: [paymentSubStep],
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    game: {
      type: Object,
      default: () => ({})
    },
    pass: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentStep: 1,
      isLoadedTransfer: true,
      selectedMethod: {
        name: '',
        currency: '',
        commission: 0,
        email: null,
        method: null,
        key: null
      },
      ipCountry: 'EU',
      languages,
      countryList: {
        RU: ['RU', 'UA', 'EU', 'USA', 'MX', 'PE', 'UY', 'CL', 'BR', 'TH', 'ID', 'PH', 'MY', 'VN', 'HK'],
        EN: ['EU', 'USA', 'UA', 'MX', 'PE', 'UY', 'CL', 'BR', 'TH', 'ID', 'PH', 'MY', 'VN', 'HK']
      },

      paymentMethod: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsToGatewayMap)),
      paymentSystemsMap: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsToSystemMap)),
      methodMaps: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsConfig)),
      allMethods: JSON.parse(JSON.stringify(paymentsMethodsInfo.allMethods)),

      filters: {
        country: 'RU',
        currency: 'RUB'
      },

      currencyRate: {
        RUB: 1,
        USD: 73,
        EUR: 80,
        EURUSD: 1,
        USDEUR: 1
      },

      amount: null,
      originalAmount: null,
      email: '',
      error: {
        status: false,
        show: false,
        message: ''
      },
      emailError: {
        status: false,
        show: false,
        message: ''
      },
      loading: false,
      newCommissions: []
    }
  },
  created() {
    this.checkActivePassOrder()
    this.getNewCommission()
    // Установить сумму из pass и сохранить оригинальную сумму покупки
    this.originalAmount = this.pass.amount[this.$store.state.currency]
    this.amount = this.originalAmount
  },
  mounted() {
    this.setUserRegion()
  },
  computed: {
    ...mapGetters(['currency', 'language', 'country']),
    paymentMethodName() {
      return getPaymentMethodName(this.selectedMethod.name)
    },
    isRussian() {
      return this.language === 'ru'
    },
    countries() {
      return this.countryList[this.language.toUpperCase()] || this.countryList.EN
    },
    selectedCountry() {
      return this.filters.country
    },
    selectedLanguage() {
      for (const language of languages) {
        if (this.filters.country === language.name.toUpperCase()) {
          return language
        }
      }

      return languages[0]
    },
    filteredMethods: function() {
      // DEPRECATED
      // const filterByCurrency = m => {
      //   return this.filters.currency === 'ALL' ? true : this.methodMaps[m].currency.includes(this.filters.currency)
      // }
      // const filterByCountry = m => {
      //   if (this.methodMaps[m].disableForRu) {
      //     return !this.isCountryRu(this.$store.state.ipCountry)
      //   } // Скрыть для русского ip
      //   return this.methodMaps[m].country.includes(this.selectedCountry)
      // }
      const sortByPriority = (a, b) => {
        return this.methodMaps[a.key]?.priority[this.selectedCountry] >
          this.methodMaps[b.key]?.priority[this.selectedCountry]
          ? 1
          : -1
      }

      const generateMultiCurrencyList = methods => {
        // const currency = this.filters.country !== 'RU' ? 'USD' : this.currency
        return methods
          .map(m => {
            // if (!this.methodMaps[m].currency.includes(this.currency)) {
            //   return this.methodMaps[m].currency.map(c => {
            //     return {
            //       key: m,
            //       name: m,
            //       currency: c,
            //       commission: this.getMethodCommission(m),
            //       iconType: this.methodMaps[m].iconType,
            //       iconName: this.methodMaps[m].iconName,
            //       email: this.methodMaps[m].email,
            //       min: this.methodMaps[m]?.min?.default
            //     }
            //   })
            // }
            return {
              key: m,
              name: m,
              currency: 'rub',
              commission: this.getMethodCommission(m),
              iconType: this.methodMaps[m].iconType,
              iconName: this.methodMaps[m].iconName,
              min: this.methodMaps[m]?.min?.default,
              email: this.methodMaps[m].email
            }
          })
          .flat()
      }
      // DEPRECATED
      // let filteredMethods = this.allMethods.filter(m => filterByCountry(m) && filterByCurrency(m))
      let filteredMethods = this.allMethods
      if (this.filters.currency === 'ALL') {
        filteredMethods = generateMultiCurrencyList(filteredMethods)
      } else {
        filteredMethods = filteredMethods.map(m => ({
          key: m,
          currency: this.filters.currency,
          commission: this.getMethodCommission(m),
          iconType: this.methodMaps[m].iconType,
          iconName: this.methodMaps[m].iconName,
          min: this.methodMaps[m]?.min?.default
        }))
      }
      return filteredMethods
        .sort((a, b) => sortByPriority(a, b))
        .filter((item, index, self) => {
          return index === self.findIndex(obj => obj.key === item.key)
        })
    },
    commissionValue() {
      if (!this.selectedMethod.name || !this.amount) return ''

      const method = this.selectedMethod.name

      if (this.shouldReturnUnknown(method)) {
        return 'Unknown'
      }

      if (this.isQiwiMethod(method)) {
        return this.calculateQiwiCommission()
      }

      const commission = this.calculateCommissionRate(method)
      const amount = Number(this.amount)

      const multipliedResult = this.calculateWithMultipliers(method, amount, commission)
      if (multipliedResult !== null) {
        return multipliedResult
      }

      if (this.paymentSystemsMap[method] === 'gm') {
        const fixFee = this.methodMaps[method]?.fix?.[this.currency] || 0
        return this.getPrice(amount, commission, fixFee).toFixed(2)
      }

      if (this.paymentSystemsMap[method] === 'gram') {
        return this.calculateGramCommission(amount)
      }

      return this.getPrice(amount, commission, 0, this.shouldUseLavaCalculation(method))
    },
    paymentIsRub() {
      return ['rub_card', 'lava', 'card_gm', 'sbp_gm', ...METHODS_ORDER].includes(this.selectedMethod.name)
    },
    isNeedEmail() {
      return this.selectedMethod.email
    },
    methodsInCustomOrder() {
      const methods = [...this.newCommissions, ...this.filteredMethods]

      const orderedMethods = this.getMethodsWithOrder(methods)

      return orderedMethods.length ? orderedMethods : methods
    },
    selectedMethodName() {
      return this.selectedMethod.method || this.selectedMethod.key
    }
  },
  watch: {
    // language(value) {
    //   if (value === 'ru' && this.filters.country === 'EU') {
    //     this.filters.country = 'RU'
    //   }
    //
    //   if (value === 'en' && this.filters.country === 'RU') {
    //     this.filters.country = 'EU'
    //   }
    //
    //   if (value !== 'ru' && this.filters.currency === 'RUB') {
    //     this.filters.currency = 'USD'
    //   }
    //
    //   const defaultMethod = this.filteredMethods[0]
    //   this.choosePaymentMethod(defaultMethod)
    // },
    // currency(value) {
    //   const defaultMethod = this.filteredMethods[0]
    //   this.choosePaymentMethod(defaultMethod.currency)
    // },
    // 'filters.country'(val) {
    //   if (!['RU', 'UA'].includes(val) && this.filters.currency === 'RUB') {
    //     this.filters.currency = 'USD'
    //   }
    // },
    amount(val) {
      if (
        this.filters.country === 'USA' &&
        this.selectedMethod.name.includes('card') &&
        this.currency.toUpperCase() === 'USD' &&
        +val > 50
      ) {
        this.amount = 50
      }
    },
    'selectedMethod.name': function(val) {
      if (val) {
        const minVar = this.methodMaps[val].min
        let minVal = null
        if (typeof minVar === 'object') {
          minVal = minVar[this.currency.toUpperCase()]
        } else {
          minVal = minVar
        }
        // Устанавливаем сумму как максимум из оригинальной суммы покупки (цены суперпасса) и минимума платежки
        // Это гарантирует, что если цена суперпасса меньше минималки платежки, то будет установлена минималка
        if (this.originalAmount && this.originalAmount >= minVal) {
          this.amount = this.originalAmount
        } else {
          this.amount = this.ceil(minVal, 2)
        }
      }
    }
  },
  methods: {
    getCommissionNewLava,

    goBack() {
      this.$emit('changeModal', {
        modal: 'TransferCharacters',
        data: []
      })
    },

    changeModal(modal) {
      this.$emit('changeModal', {
        modal
      })
    },

    goToNextStep() {
      if (!this.selectedMethod.name) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.empty'),
          type: 'error'
        })
        return
      }

      if (this.paymentIsRub) {
        this.validatePrice()
      }
      if (this.isNeedEmail) {
        this.validateEmail()
      }

      const errorMessage = this.error.message || this.emailError.message

      if (errorMessage) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: errorMessage,
          type: 'error'
        })
        return
      }

      // Сохранение данных текущего шага в store
      this.$store.commit('paymentsOrder/setAmount', Number(this.amount))
      this.$store.commit('paymentsOrder/setCurrency', this.currency)
      this.$store.commit('paymentsOrder/setEmail', this.email)
      this.$store.commit('paymentsOrder/setRobuxAmount', this.pass.robux)
      this.$store.commit('paymentsOrder/setRobloxData', {
        nickname: this.data.nickname
      })
      this.$store.commit('paymentsOrder/setSelectedMethod', {
        name: this.selectedMethod.name,
        key: this.selectedMethod.key,
        commission: this.selectedMethod.commission,
        iconType: this.selectedMethod.iconType,
        iconName: this.selectedMethod.iconName
      })
      this.$store.commit('paymentsOrder/setCommission', this.commissionValue)
      this.$store.commit('paymentsOrder/setTotalToPay', this.commissionValue)
      // Сохраняем информацию о SuperPass
      this.$store.commit('paymentsOrder/setSuperPassData', {
        isSuperPass: true,
        superPassId: this.pass.id
      })

      // Переход на шаг 2 для подтверждения
      this.currentStep = 2
    },

    async checkActivePassOrder() {
      const requestHeaders = new Headers({
        Authorization: `Bearer ${this.$cookies.get('access_token')}`
      })

      const requestParams = {
        method: 'GET',
        headers: requestHeaders
      }

      try {
        const response = await fetch('https://transfer.backend-pier.com/active_superpass_orders_new', requestParams)
        const data = await response.json()
        const activeInGameOrders = data.orders ? data.orders.filter(order => order.in_game) : []
        const isActiveOrder = !!activeInGameOrders.length && this.game.in_game

        if (isActiveOrder) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('superPass.purchase.activeOrder'),
            type: 'warning'
          })

          await this.$router.push({
            name: 'History',
            query: { method: 'superPass' }
          })
        } else {
          this.isLoadedTransfer = false
        }
      } catch (error) {
        console.error('Error fetching active pass order:', error)
        this.isLoadedTransfer = false
      } finally {
        this.isLoadedTransfer = false
      }
    },

    async checkSuperPassStock() {
      const requestHeaders = new Headers({
        Authorization: `Bearer ${this.$cookies.get('access_token')}`
      })

      const requestParams = {
        method: 'GET',
        headers: requestHeaders
      }

      try {
        const response = await fetch('https://transfer.backend-pier.com/superpass_stock_new', requestParams)
        const data = await response.json()

        if (data.suppliers) {
          return data.suppliers.length
        } else {
          this.isLoadedTransfer = false
        }
      } catch (error) {
        console.error('Error fetching active pass order:', error)
      } finally {
        this.isLoadedTransfer = false
      }
    },

    isCountryRu(c) {
      return ipUtil.isCountryRu(c)
    },

    getMethodCommission(method) {
      if (typeof this.methodMaps[method].commission === 'object') {
        const key = Object.keys(this.methodMaps[method].commission)
        if (key.includes(this.filters.country)) {
          return this.methodMaps[method].commission[this.filters.country]
        }
        return this.methodMaps[method].commission.default
      }
      return this.methodMaps[method].commission
    },

    setUserRegion() {
      const EU_COUNRIES = [
        'AU',
        'BE',
        'BG',
        'GB',
        'HU',
        'DE',
        'GR',
        'DK',
        'IE',
        'ES',
        'IT',
        'LV',
        'LT',
        'LU',
        'MT',
        'LI',
        'NL',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'FI',
        'FR',
        'HR',
        'CZ',
        'SE',
        'EE',
        'BA',
        'IE',
        'IS',
        'NO'
      ]
      const RU_COUNRIES = ['AZ', 'AM', 'BY', 'KZ', 'KG', 'MD', 'TJ', 'UZ', 'TM', 'GE']
      const SELECTED_COUNTRIES = ['RU', 'UA', 'EU', 'USA', 'MX', 'PE', 'UY', 'CL', 'BR']

      if (EU_COUNRIES.includes(this.country)) {
        this.filters.country = 'EU'
      } else if (RU_COUNRIES.includes(this.country)) {
        this.filters.country = 'RU'
      } else if (SELECTED_COUNTRIES.includes(this.country)) {
        this.filters.country = this.country
      } else {
        this.filters.country = 'RU'
      }
    },

    ceil(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },

    async createOrder() {
      // Проверяем наличие SuperPass в наличии
      if (!(await this.checkSuperPassStock())) {
        this.changeModal('SuperPassStockInfo')
        return
      }

      if (!this.selectedMethod.name) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.empty'),
          type: 'error'
        })
        return
      }

      if (this.paymentIsRub) {
        this.validatePrice()
      }

      const errorMessage = this.error.message || this.emailError.message

      if (errorMessage) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: errorMessage,
          type: 'error'
        })
        return
      }

      this.loading = true

      try {
        // Шаг 1: Создаем заказ SuperPass
        const orderResult = await this.$store.dispatch('paymentsOrder/makeOrder', {
          withReplenish: true
        })

        if (!orderResult) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('payment.errors.server'),
            type: 'error'
          })
          this.loading = false
          return
        }

        // Проверка на status: false в ответе
        if (orderResult.status === false) {
          const errorMessage = orderResult.message || orderResult.error || 'Не удалось создать заказ'
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: errorMessage,
            type: 'error'
          })
          this.loading = false
          return
        }

        // Обработка ответа - проверяем, что error не пустая строка
        if (orderResult.error && orderResult.error.length > 0) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: orderResult.error,
            type: 'error'
          })
          this.loading = false
          return
        }

        // Получаем ID заказа из разных вариантов структуры ответа
        const orderId = orderResult?.order?._id || orderResult?.data?._id || orderResult?.data?.id || orderResult?.id

        if (!orderId) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: 'Не удалось получить ID заказа',
            type: 'error'
          })
          this.loading = false
          return
        }

        // Получаем userId из store
        const userId = this.$store.state.account.userId

        if (!userId) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: 'Не удалось получить ID пользователя',
            type: 'error'
          })
          this.loading = false
          return
        }

        // Шаг 2: Создаем платеж через makePayment
        const paymentResult = await makePayment(
          {
            name: this.selectedMethod.name,
            key: this.selectedMethod.key,
            method: this.selectedMethod.method
          },
          orderId,
          userId,
          Number(this.amount),
          this.email,
          this.currency
        )

        if (paymentResult?.redirect_uri) {
          // Отправляем аналитику для SuperPass
          this.$analytics.send('topup', {
            topup_id: paymentResult.id || orderId,
            source: 'superpass'
          })

          // Перенаправляем на страницу оплаты
          location.href = paymentResult.redirect_uri
        } else {
          this.$analytics.send('topup_error', {
            source: 'superpass'
          })

          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: 'Не удалось создать платеж. Попробуйте позже',
            type: 'error'
          })
        }
      } catch (error) {
        this.$analytics.send('topup_error', {
          source: 'superpass'
        })

        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.server'),
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    choosePaymentMethod(method, isLava = false) {
      this.selectedMethod.method = null
      this.selectedMethod.percent = null
      this.selectedMethod.status = null

      this.error = {
        status: false,
        show: false,
        message: ''
      }
      this.emailError = {
        status: false,
        show: false,
        message: ''
      }

      this.selectedMethod.name = method.key
      this.selectedMethod.key = method.key
      this.selectedMethod.method = method.key
      this.selectedMethod.currency = method.currency
      this.selectedMethod.commission = method.commission
      this.selectedMethod.iconType = method.iconType
      this.selectedMethod.min = method.min
      this.selectedMethod.email = method.email
      this.selectedMethod.iconName = method.iconName

      if (isLava) {
        this.selectedMethod = { ...method }
        this.selectedMethod.name = 'lava'
        this.selectedMethod.min = 10
        this.selectedMethod.iconName = method.iconName
      }
    },

    validatePrice() {
      const isCustomMinValue = ['lava', 'rub_card', 'sbp_gm', 'card_gm', ...METHODS_ORDER].includes(
        this.selectedMethod?.name
      )
      const min = isCustomMinValue ? this.selectedMethod?.min : 100

      if (isNaN(this.amount)) {
        this.error.status = false
        this.error.show = true
        this.error.message = 'Введите корректную сумму'
      } else if (this.amount < min) {
        this.error.status = false
        this.error.show = true
        this.error.message = `Сумма пополнения должна быть не менее ${min}`
      } else {
        this.error.status = true
        this.error.show = false
        this.error.message = ''
      }
    },

    validateEmail() {
      let errorMessage = ''
      let emailState = true

      if (this.email.length === 0) {
        errorMessage = 'Поле E-mail пустое'
        emailState = false
      } else if (validateEmail(this.email) === false) {
        errorMessage = 'Введённая почта неверная!'
        emailState = false
      } else {
        errorMessage = ''
        emailState = true
      }

      this.emailError.status = emailState
      this.emailError.show = !emailState
      this.emailError.message = errorMessage
    },

    async getNewCommission() {
      try {
        const response = await fetch('https://payments.backend-pier.com/api/v1/topups/lava_commissions')
        const data = await response.json()
        const { commissions } = data
        this.newCommissions = commissions
          ?.filter(item => item.status)
          .map(item => {
            return { ...item, name: 'lava', key: 'lava_' + item.method }
          })
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },

    getMethodsWithOrder(currentList) {
      const filteredList = []

      METHODS_ORDER.forEach(methodName => {
        const method = currentList.find(item => item.key === methodName)
        if (method) filteredList.push(method)
      })
      return filteredList
    },

    shouldReturnUnknown(method) {
      return ['new_fk', 'payok'].includes(method)
    },

    isQiwiMethod(method) {
      return method === 'qiwi'
    },

    calculateQiwiCommission() {
      const commission = this.methodMaps.qiwi.commission
      return Math.ceil((Number(this.amount) + (this.amount * commission) / 100) * 100) / 100
    },

    calculateCommissionRate(method) {
      if (this.selectedMethod.percent) {
        return Number(1 - this.selectedMethod.percent) * 100
      }

      const methodCommission = this.methodMaps[method]?.commission

      if (typeof methodCommission !== 'object') {
        return methodCommission
      }

      return methodCommission[this.filters.country] || methodCommission.default
    },

    getPrice(amount, commission, multiplier = 0, useLavaFormula = false) {
      if (useLavaFormula) {
        const resultLava = amount / (1 - commission / 100)
        return Number(resultLava.toFixed(2))
      }

      const result = amount + (amount * commission) / 100 + multiplier
      return Number(result.toFixed(2))
    },

    shouldUseLavaCalculation(method) {
      return this.selectedMethod.percent || ['cardlink', 'cardlink_sbp', 'cardlink_copy', 'lava'].includes(method)
    },

    calculateWithMultipliers(method, amount, commission) {
      const multipliers = {
        redpagos: {
          RUB: 0.5 * this.currencyRate.USD,
          EUR: 0.5 * this.currencyRate.USDEUR,
          USD: 0.5
        },
        servipag: {
          RUB: 1.5 * this.currencyRate.USD,
          EUR: 1.5 * this.currencyRate.USDEUR,
          USD: 1.5
        },
        boleto: {
          RUB: this.currencyRate.USD,
          EUR: this.currencyRate.USDEUR,
          USD: 1
        }
      }

      if (multipliers[method] && multipliers[method][this.currency]) {
        return this.getPrice(amount, commission, multipliers[method][this.currency])
      }

      if (method === 'card_gm') {
        return this.calculateCardGmCommission(amount, commission)
      }

      return null
    },

    calculateCardGmCommission(amount, commission) {
      const cardGmMultipliers = {
        EU: {
          RUB: 0.1 * this.currencyRate.EUR,
          EUR: 0.1,
          USD: 0.1 * this.currencyRate.EURUSD
        },
        default: {
          RUB: 0.12 * this.currencyRate.EUR,
          EUR: 0.12,
          USD: 0.12 * this.currencyRate.EURUSD
        }
      }

      const multiplierConfig = ['RU', 'UA', 'EU'].includes(this.filters.country)
        ? cardGmMultipliers.EU
        : cardGmMultipliers.default

      if (multiplierConfig[this.currency]) {
        return this.getPrice(amount, commission, multiplierConfig[this.currency])
      }

      return null
    },

    calculateGramCommission(amount) {
      const c = Number(amount / 7).toFixed(2)
      const minCommission = 4.9 / this.currencyRate[this.currency]

      if (c > minCommission) {
        return Math.ceil((amount + Number(c)) * 100) / 100
      } else {
        return Math.ceil((amount + minCommission) * 100) / 100
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../Transfer/transferPaymentMethod/transferPaymentMethod.scss';
@import '../superPassPurchase/superPassPurchase';

.transfer-payment-method {
  .form-layout__title-wrap {
    margin-bottom: 20px;
  }

  .payments-step-2 {
    gap: 0;

    .payments-step-2__info {
      gap: 0;
      > .purchase-pass-card {
        margin-bottom: 10px;
      }

      &Pay {
        margin: 12px 0;
      }
    }

    .payments-step-2__method {
      > .base-input.size_lg {
        margin-bottom: 12px;
      }
    }
  }
}

@media screen and (max-width: 1919px) {
  .transfer-payment-method {
    .form-layout__title-wrap {
      margin-bottom: 20px;
    }
  }
}

@media screen and (max-width: 743px) {
  .transfer-payment-method {
    .form-layout__title-wrap {
      margin-bottom: 16px;
    }

    .payments-step-2 {
      .payments-step-2__info {
        &Pay {
          margin: 12px 0;
          gap: 12px;
        }
      }
    }
  }
}

.superpass-info-item {
  margin-bottom: 16px;

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
  }
}
</style>
